// extracted by mini-css-extract-plugin
export default {"trigger":"NotificationTrigger_trigger_yoheb","clearBtn":"NotificationTrigger_clearBtn_1HkJT"};